var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.locating,
          expression: "locating",
        },
      ],
      staticClass: "drive-explorer",
      attrs: { "element-loading-text": "正在定位所在目录…", tabindex: "0" },
      on: {
        contextmenu: _vm.showBlankMenu,
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.externalDriveOver.apply(null, arguments)
        },
        dragleave: _vm.leave,
        drop: function ($event) {
          $event.preventDefault()
          return _vm.dropByLocation.apply(null, arguments)
        },
        "!paste": function ($event) {
          return _vm.paste.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "header",
        { staticClass: "drive-heading" },
        [
          _c(
            "div",
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.space.ownerName || "我的") + "的文件"),
              ]),
              _c("p", [
                _vm._v(
                  "个人空间 · " +
                    _vm._s(_vm.fmt(_vm.space.usedBytes || 0)) +
                    " / " +
                    _vm._s(_vm.fmt(_vm.space.quotaBytes || 2147483648))
                ),
                _vm.space.reservedBytes
                  ? _c("span", [
                      _vm._v(
                        " · 上传预占 " +
                          _vm._s(_vm.fmt(_vm.space.reservedBytes))
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("el-progress", {
                attrs: {
                  percentage: Math.min(
                    100,
                    Math.round(
                      ((Number(_vm.space.usedBytes || 0) +
                        Number(_vm.space.reservedBytes || 0)) /
                        Number(_vm.space.quotaBytes || 2147483648)) *
                        100
                    )
                  ),
                  "show-text": false,
                },
              }),
            ],
            1
          ),
          !_vm.adminView
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-setting" },
                  on: { click: _vm.showSettings },
                },
                [_vm._v("设置")]
              )
            : _vm._e(),
          _vm._t("head"),
        ],
        2
      ),
      _c("nav", { staticClass: "drive-tabs" }, [
        _c(
          "button",
          {
            class: { active: _vm.mode === "files" },
            on: {
              click: function ($event) {
                return _vm.switchMode("files")
              },
            },
          },
          [_vm._v("我的文件")]
        ),
        _c(
          "button",
          {
            class: { active: _vm.mode === "tags" },
            on: {
              click: function ($event) {
                return _vm.switchMode("tags")
              },
            },
          },
          [_vm._v("智能分类")]
        ),
        _c(
          "button",
          {
            class: { active: _vm.mode === "trash" },
            on: {
              click: function ($event) {
                return _vm.switchMode("trash")
              },
            },
          },
          [_vm._v("回收站")]
        ),
        _vm.mode === "trash"
          ? _c("span", [_vm._v("保留30天，未彻底清除仍占容量")])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "drive-toolbar" },
        [
          _c("el-input", {
            staticClass: "drive-search-input",
            attrs: {
              clearable: "",
              placeholder: "搜索文件名或内容",
              title: "搜索当前人员所有文件和目录",
              "prefix-icon": "el-icon-search",
            },
            on: { input: _vm.search },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _vm.mode === "tags"
            ? _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "全部已打标签文件",
                  },
                  on: {
                    change: function ($event) {
                      _vm.page = 1
                      _vm.load()
                    },
                  },
                  model: {
                    value: _vm.tagId,
                    callback: function ($$v) {
                      _vm.tagId = $$v
                    },
                    expression: "tagId",
                  },
                },
                _vm._l(_vm.tags, function (tag) {
                  return _c("el-option", {
                    key: tag.id,
                    attrs: { value: tag.id, label: tag.name },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "el-select",
            {
              on: {
                change: function ($event) {
                  _vm.page = 1
                  _vm.load()
                },
              },
              model: {
                value: _vm.sort,
                callback: function ($$v) {
                  _vm.sort = $$v
                },
                expression: "sort",
              },
            },
            _vm._l(_vm.sorts, function (option) {
              return _c("el-option", {
                key: option.value,
                attrs: { value: option.value, label: option.label },
              })
            }),
            1
          ),
          _c("el-button", { on: { click: _vm.refresh } }, [_vm._v("刷新")]),
          _vm.mode === "files"
            ? [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.newFolder()
                      },
                    },
                  },
                  [_vm._v("新建目录")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$refs.folderInput.click()
                      },
                    },
                  },
                  [_vm._v("上传文件夹")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.fileInput.click()
                      },
                    },
                  },
                  [_vm._v("上传文件")]
                ),
              ]
            : _vm._e(),
          _c(
            "el-button-group",
            { staticClass: "drive-view-toggle" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.viewMode === "list" ? "primary" : "",
                    icon: "el-icon-tickets",
                    "aria-label": "列表视图",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setView("list")
                    },
                  },
                },
                [_vm._v("列表")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.viewMode === "grid" ? "primary" : "",
                    icon: "el-icon-menu",
                    "aria-label": "宫格视图",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setView("grid")
                    },
                  },
                },
                [_vm._v("宫格")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.viewMode === "columns" ? "primary" : "",
                    icon: "el-icon-s-unfold",
                    "aria-label": "分栏视图",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setView("columns")
                    },
                  },
                },
                [_vm._v("分栏")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("input", {
        ref: "fileInput",
        staticClass: "hidden-input",
        attrs: { type: "file", multiple: "" },
        on: { change: _vm.selectFiles },
      }),
      _c("input", {
        ref: "folderInput",
        staticClass: "hidden-input",
        attrs: { type: "file", webkitdirectory: "", multiple: "" },
        on: { change: _vm.selectFolder },
      }),
      _vm.mode === "files" && !_vm.keyword
        ? _c(
            "div",
            { staticClass: "drive-breadcrumb" },
            [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openFolder(0)
                    },
                  },
                },
                [_vm._v("全部文件")]
              ),
              _vm._l(_vm.trail, function (item) {
                return [
                  _c("span", { key: item.id + "s" }, [_vm._v(" / ")]),
                  _c(
                    "button",
                    {
                      key: item.id,
                      on: {
                        click: function ($event) {
                          return _vm.openFolder(item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.mapping.enabled
        ? _c("p", { staticClass: "drive-sync-summary" }, [
            _c("i", { staticClass: "el-icon-connection" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.mapping.running && _vm.mapping.working.length
                    ? "正在同步本机目录…"
                    : "本机目录映射已开启"
                )
            ),
            _vm.mapping.error
              ? _c("span", { staticClass: "drive-sync-warning" }, [
                  _vm._v(" · " + _vm._s(_vm.mapping.error) + "，稍后自动重试"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.dragging
        ? _c("div", { staticClass: "drop-cover" }, [
            _vm._v("拖到这里上传至当前目录"),
          ])
        : _vm._e(),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: _vm.error,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.viewMode === "list"
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.shownRows,
                "row-class-name": _vm.driveRowClass,
                "row-key": "id",
                "empty-text": "暂无文件，可上传文件或拖入文件夹",
              },
              on: {
                "row-dblclick": _vm.openItem,
                "row-contextmenu": _vm.showNodeMenu,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "名称", "min-width": "260" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "drive-name",
                              attrs: {
                                "data-drive-reveal-node": row.id,
                                "data-drive-upload-node": row.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openItem(row)
                                },
                                mousedown: function ($event) {
                                  return _vm.startDriveDrag($event, row)
                                },
                                dragstart: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("drive-thumb", {
                                attrs: {
                                  row: row,
                                  "owner-id": _vm.ownerId,
                                  syncing: _vm.nodeSyncing(row),
                                },
                              }),
                              _c(
                                "div",
                                [
                                  _c("strong", [_vm._v(_vm._s(row.name))]),
                                  row.pending
                                    ? _c("small", [_vm._v("正在同步…")])
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "drive-row-tags" },
                                    _vm._l(row.tags, function (tag) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: tag.id,
                                          attrs: { size: "mini" },
                                        },
                                        [_vm._v(_vm._s(tag.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _c("drive-matches", {
                                    attrs: { row: row, keyword: _vm.keyword },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2692018118
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "大小", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            _vm._s(
                              row.pending
                                ? "同步中"
                                : row.kind === "DIR"
                                ? "目录"
                                : _vm.fmt(row.fileSize)
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3790875336
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.mode === "trash" ? "删除时间" : "创建时间",
                  "min-width": "165",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.mode === "trash"
                                ? row.deletedAt
                                : row.createdAt
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3038011041
                ),
              }),
              _vm.mode === "tags"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "taggedAt",
                      label: "打标签时间",
                      "min-width": "165",
                    },
                  })
                : _vm._e(),
              _vm.mode === "trash"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "expiresAt",
                      label: "回收站到期",
                      "min-width": "165",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "操作", width: "230" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm.mode === "trash"
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restore(row)
                                      },
                                    },
                                  },
                                  [_vm._v("恢复")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.purge(row)
                                      },
                                    },
                                  },
                                  [_vm._v("彻底清除")]
                                ),
                              ]
                            : !row.pending
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadEntry(row)
                                      },
                                    },
                                  },
                                  [_vm._v("下载")]
                                ),
                                row.kind === "FILE"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openTags(row)
                                          },
                                        },
                                      },
                                      [_vm._v("打标签")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showNodeMenu(row, $event)
                                      },
                                    },
                                  },
                                  [_vm._v("更多")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.trash(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2702455235
                ),
              }),
            ],
            1
          )
        : _vm.viewMode === "grid"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "drive-grid",
            },
            [
              _vm._l(_vm.shownRows, function (row) {
                return _c(
                  "article",
                  {
                    key: row.id,
                    staticClass: "drive-grid-card",
                    class: {
                      "drive-located": _vm.nodeLocated(row),
                      pending: row.pending,
                      "drive-upload-target":
                        _vm.externalDropTarget &&
                        String(_vm.externalDropTarget.rowId) === String(row.id),
                    },
                    attrs: {
                      "data-drive-reveal-node": row.id,
                      "data-drive-upload-node": row.id,
                    },
                    on: {
                      dblclick: function ($event) {
                        return _vm.openItem(row)
                      },
                      contextmenu: function ($event) {
                        return _vm.showNodeMenu(row, $event)
                      },
                      mousedown: function ($event) {
                        return _vm.startDriveDrag($event, row)
                      },
                      dragstart: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "drive-grid-more",
                        attrs: { "aria-label": "文件操作" },
                        on: {
                          mousedown: function ($event) {
                            $event.stopPropagation()
                          },
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showNodeMenu(row, $event)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-more" })]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "drive-grid-image",
                        on: {
                          click: function ($event) {
                            return _vm.openItem(row)
                          },
                        },
                      },
                      [
                        _c("drive-thumb", {
                          attrs: {
                            row: row,
                            "owner-id": _vm.ownerId,
                            syncing: _vm.nodeSyncing(row),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "drive-grid-name",
                        attrs: { title: row.name },
                        on: {
                          click: function ($event) {
                            return _vm.openItem(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.name))]
                    ),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          row.pending
                            ? "正在同步…"
                            : row.kind === "DIR"
                            ? "文件夹"
                            : _vm.fmt(row.fileSize)
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "drive-row-tags" },
                      _vm._l(row.tags, function (tag) {
                        return _c(
                          "el-tag",
                          { key: tag.id, attrs: { size: "mini" } },
                          [_vm._v(_vm._s(tag.name))]
                        )
                      }),
                      1
                    ),
                    _c("drive-matches", {
                      attrs: { row: row, keyword: _vm.keyword, compact: "" },
                    }),
                  ],
                  1
                )
              }),
              !_vm.shownRows.length && !_vm.loading
                ? _c("p", { staticClass: "drive-empty" }, [
                    _vm._v("暂无文件，可上传文件或拖入文件夹"),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "columns",
              staticClass: "drive-columns",
              attrs: { "aria-label": "文件分栏浏览" },
            },
            _vm._l(_vm.columns, function (column, index) {
              return _c(
                "section",
                {
                  key: column.parentId + "-" + index,
                  staticClass: "drive-column",
                  class: [
                    _vm.columnDropClass(column, index),
                    { "drive-search-column": !!_vm.keyword.trim() },
                  ],
                  attrs: {
                    "data-drive-column": index,
                    "aria-label": column.name,
                  },
                  on: {
                    dragover: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.externalColumnOver.apply(null, arguments)
                    },
                    dragleave: function ($event) {
                      $event.stopPropagation()
                      return _vm.externalColumnLeave.apply(null, arguments)
                    },
                    drop: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.dropIntoColumn.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("header", { staticClass: "drive-column-head" }, [
                    _c("strong", { attrs: { title: column.name } }, [
                      _vm._v(_vm._s(column.name)),
                    ]),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          index === _vm.columns.length - 1
                            ? "当前目录"
                            : column.total + " 项"
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: column.loading,
                          expression: "column.loading",
                        },
                      ],
                      staticClass: "drive-column-items",
                    },
                    [
                      _vm._l(_vm.columnRows(column), function (row) {
                        return _c(
                          "button",
                          {
                            key: row.id,
                            staticClass: "drive-column-row",
                            class: [
                              {
                                "drive-located": _vm.nodeLocated(row),
                                "search-result": !!_vm.keyword.trim(),
                                selected: _vm.columnSelected(column, row),
                                pending: row.pending,
                              },
                              _vm.columnDropClass(column, index, row),
                            ],
                            attrs: {
                              type: "button",
                              "data-drive-reveal-node": row.id,
                              "data-drive-node": row.id,
                              title: row.name,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.chooseColumnRow(column, row)
                              },
                              contextmenu: function ($event) {
                                return _vm.showNodeMenu(row, $event)
                              },
                              mousedown: function ($event) {
                                return _vm.startColumnDrag($event, column, row)
                              },
                              dragstart: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            _c("drive-thumb", {
                              attrs: {
                                row: row,
                                "owner-id": _vm.ownerId,
                                syncing: _vm.nodeSyncing(row),
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "drive-column-copy" },
                              [
                                _c("span", [_vm._v(_vm._s(row.name))]),
                                _c("drive-matches", {
                                  attrs: {
                                    row: row,
                                    keyword: _vm.keyword,
                                    compact: "",
                                  },
                                }),
                              ],
                              1
                            ),
                            row.kind === "DIR"
                              ? _c("i", { staticClass: "el-icon-arrow-right" })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      column.error
                        ? _c(
                            "p",
                            { staticClass: "drive-column-empty" },
                            [
                              _vm._v(_vm._s(column.error)),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.fetchColumn(column)
                                    },
                                  },
                                },
                                [_vm._v("重试")]
                              ),
                            ],
                            1
                          )
                        : !column.loading && !_vm.columnRows(column).length
                        ? _c("p", { staticClass: "drive-column-empty" }, [
                            _vm._v("暂无文件"),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  column.total > 50
                    ? _c("el-pagination", {
                        attrs: {
                          small: "",
                          "current-page": column.page,
                          "page-size": 50,
                          total: column.total,
                          layout: "prev,next",
                        },
                        on: {
                          "current-change": function ($event) {
                            return _vm.changeColumnPage(column, $event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
      _vm.viewMode !== "columns"
        ? _c("el-pagination", {
            attrs: {
              "current-page": _vm.page,
              "page-size": 50,
              total: _vm.total,
              layout: "total,prev,pager,next",
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.page = $event
              },
              "update:current-page": function ($event) {
                _vm.page = $event
              },
              "current-change": _vm.load,
            },
          })
        : _vm._e(),
      _vm.uploads.length
        ? _c(
            "div",
            { staticClass: "drive-uploads" },
            [
              _c(
                "div",
                { staticClass: "upload-head" },
                [
                  _c("strong", [_vm._v("上传任务（最多3项并发）")]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.clearFinished },
                    },
                    [_vm._v("清除已完成")]
                  ),
                ],
                1
              ),
              _vm._l(_vm.uploads, function (task) {
                return _c(
                  "div",
                  { key: task.id, staticClass: "upload-task" },
                  [
                    _c("span", [_vm._v(_vm._s(task.name))]),
                    _c("el-progress", {
                      attrs: {
                        percentage: task.progress,
                        status:
                          task.state === "failed"
                            ? "exception"
                            : task.state === "done"
                            ? "success"
                            : undefined,
                      },
                    }),
                    _c("small", [_vm._v(_vm._s(task.message))]),
                    ["queued", "uploading", "packing"].includes(task.state) &&
                    task.progress < 99
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                task.cancelled = true
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    task.state === "failed"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.retry(task)
                              },
                            },
                          },
                          [_vm._v("重试")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.columnDrag
        ? _c(
            "div",
            {
              staticClass: "drive-move-ghost",
              class: { denied: _vm.columnDrag.reason },
              style: {
                left: _vm.columnDrag.x + "px",
                top: _vm.columnDrag.y + "px",
              },
            },
            [
              _c("strong", [_vm._v(_vm._s(_vm.columnDrag.row.name))]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.columnDrag.reason ||
                      "松开移动到：" + _vm.columnDrag.targetName
                  )
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.externalDropTarget
        ? _c("p", { staticClass: "drive-drop-caption" }, [
            _vm._v("松开上传到：" + _vm._s(_vm.externalDropTarget.name)),
          ])
        : _vm._e(),
      _c("p", { staticClass: "drive-tip" }, [
        _vm._v(
          "支持文件/文件夹拖入、Ctrl+V 粘贴上传；电脑客户端可将文件和目录拖出下载。"
        ),
      ]),
      _vm.contextMenu
        ? _c(
            "div",
            {
              staticClass: "drive-context",
              style: {
                left: _vm.contextMenu.x + "px",
                top: _vm.contextMenu.y + "px",
              },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.contextMenu.blank
                ? [
                    _c("button", { on: { click: _vm.newFolderFromMenu } }, [
                      _vm._v("新建目录"),
                    ]),
                  ]
                : _vm.mode === "trash"
                ? [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.restore(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("恢复")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.purge(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("彻底清除")]
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.openItem(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("打开")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.revealInDrive(_vm.contextMenu.row)
                          },
                        },
                      },
                      [_vm._v("打开所在目录")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.chooseDestination(
                              _vm.contextMenu.row,
                              "copy"
                            )
                          },
                        },
                      },
                      [_vm._v("复制")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.chooseDestination(
                              _vm.contextMenu.row,
                              "move"
                            )
                          },
                        },
                      },
                      [_vm._v("移动")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.rename(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("重命名")]
                    ),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.downloadEntry(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("下载")]
                    ),
                    _vm.contextMenu.row.kind === "FILE"
                      ? _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.openTags(_vm.contextMenu.row)
                                _vm.contextMenu = null
                              },
                            },
                          },
                          [_vm._v("打标签")]
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        attrs: {
                          disabled: !_vm.canMap || !_vm.mapping.enabled,
                        },
                        on: {
                          click: function ($event) {
                            _vm.revealLocal(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.contextMenu.row.kind === "DIR"
                              ? "打开本地目录"
                              : "打开本地所在目录"
                          )
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            _vm.trash(_vm.contextMenu.row)
                            _vm.contextMenu = null
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文件管理设置",
            visible: _vm.settingsDialog,
            width: "650px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.settingsDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drive-setting-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("个人空间")]),
                _c("p", [
                  _vm._v(
                    "当前总容量 " + _vm._s(_vm.fmt(_vm.space.quotaBytes || 0))
                  ),
                ]),
              ]),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.quotaDialog = true
                      _vm.loadRequests()
                    },
                  },
                },
                [_vm._v("申请扩容")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "drive-setting-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("映射到本机目录")]),
                _c("p", [
                  _vm._v("本机与云端双向同步；本机删除会进入云端回收站。"),
                ]),
              ]),
              _c("el-switch", {
                attrs: {
                  value: !!_vm.mapping.enabled,
                  disabled: !_vm.canMap || _vm.mappingBusy,
                },
                on: { change: _vm.toggleMapping },
              }),
            ],
            1
          ),
          !_vm.canMap
            ? _c("p", { staticClass: "drive-tip" }, [
                _vm._v("本机目录映射需要使用新版电脑客户端。"),
              ])
            : [
                _c("p", { staticClass: "drive-tip" }, [
                  _vm._v("关闭映射会停止同步，保留已下载到本机的文件。"),
                ]),
                _vm.mapping.path
                  ? _c("el-input", {
                      attrs: {
                        value: _vm.mapping.path,
                        readonly: "",
                        "aria-label": "本机映射目录",
                      },
                    })
                  : _vm._e(),
                _vm.mapping.error
                  ? _c("el-alert", {
                      attrs: {
                        title: _vm.mapping.error,
                        type: "warning",
                        closable: false,
                      },
                    })
                  : _vm._e(),
              ],
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.settingsDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.destinationAction === "copy" ? "复制到目录" : "移动到目录",
            visible: _vm.destinationDialog,
            width: "620px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.destinationDialog = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.destinationNode && _vm.destinationNode.name)),
          ]),
          _c(
            "div",
            { staticClass: "drive-breadcrumb" },
            [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openTarget(0)
                    },
                  },
                },
                [_vm._v("全部文件")]
              ),
              _vm._l(_vm.targetTrail, function (item) {
                return [
                  _c("span", { key: item.id + "s" }, [_vm._v(" / ")]),
                  _c(
                    "button",
                    {
                      key: item.id,
                      on: {
                        click: function ($event) {
                          return _vm.openTarget(item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ]
              }),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.targetLoading,
                  expression: "targetLoading",
                },
              ],
              staticClass: "drive-destination",
            },
            [
              _vm._l(_vm.targetRows, function (row) {
                return _c(
                  "button",
                  {
                    key: row.id,
                    attrs: {
                      disabled:
                        _vm.destinationNode &&
                        String(row.id) === String(_vm.destinationNode.id),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openTarget(row.id)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-folder" }),
                    _vm._v(" " + _vm._s(row.name)),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                )
              }),
              !_vm.targetRows.length
                ? _c("p", [_vm._v("此目录下没有更多文件夹")])
                : _vm._e(),
            ],
            2
          ),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.targetPage,
              "page-size": 100,
              total: _vm.targetTotal,
              layout: "prev,pager,next",
            },
            on: {
              "current-change": function ($event) {
                return _vm.openTarget(_vm.targetParent, $event)
              },
            },
          }),
          _vm.invalidDestination
            ? _c("el-alert", {
                attrs: {
                  title: "不能选择自身或子目录",
                  type: "warning",
                  closable: false,
                },
              })
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.destinationDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.invalidDestination || _vm.targetLoading,
                    loading: _vm.destinationBusy,
                  },
                  on: { click: _vm.commitDestination },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.destinationAction === "copy"
                        ? "复制到此目录"
                        : "移动到此目录"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文件标签",
            visible: _vm.tagDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tagDialog = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.tagFile && _vm.tagFile.name) +
                " · 点击标签立即保存，再点一次取消关联"
            ),
          ]),
          _vm._l(_vm.tagGroups, function (group) {
            return _c("div", { key: group, staticClass: "tag-group" }, [
              _c("strong", [_vm._v(_vm._s(group))]),
              _c(
                "div",
                _vm._l(
                  _vm.tags.filter((t) => t.category === group),
                  function (tag) {
                    return _c(
                      "el-button",
                      {
                        key: tag.id,
                        attrs: {
                          size: "small",
                          type: _vm.selectedTags.includes(String(tag.id))
                            ? "primary"
                            : "",
                          loading: _vm.pendingTags.includes(String(tag.id)),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleTag(tag)
                          },
                        },
                      },
                      [_vm._v(_vm._s(tag.name))]
                    )
                  }
                ),
                1
              ),
            ])
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.tagDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申请增加个人空间",
            visible: _vm.quotaDialog,
            width: "620px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.quotaDialog = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(
              "当前总容量 " +
                _vm._s(_vm.fmt(_vm.space.quotaBytes || 0)) +
                "，填写希望调整后的总容量。"
            ),
          ]),
          _c("el-input-number", {
            attrs: {
              min:
                Math.floor(
                  Number(_vm.space.quotaBytes || 2147483648) / 1048576
                ) + 1,
              max: 10240,
              step: 100,
            },
            model: {
              value: _vm.requestedMiB,
              callback: function ($$v) {
                _vm.requestedMiB = $$v
              },
              expression: "requestedMiB",
            },
          }),
          _c("span", [_vm._v(" MiB")]),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              maxlength: "500",
              placeholder: "请填写用途和扩容原因",
            },
            model: {
              value: _vm.quotaReason,
              callback: function ($$v) {
                _vm.quotaReason = $$v
              },
              expression: "quotaReason",
            },
          }),
          _c(
            "el-table",
            { attrs: { data: _vm.requests } },
            [
              _c("el-table-column", {
                attrs: { label: "申请总容量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.fmt(row.requestedBytes)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.quotaStatus(row.status)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewNote", label: "审核意见" },
              }),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.quotaDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.applying },
                  on: { click: _vm.applyQuota },
                },
                [_vm._v("提交申请")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.preview
        ? _c("file-preview", {
            attrs: {
              file: _vm.preview,
              loader: _vm.previewLoader,
              "can-download": true,
            },
            on: {
              close: function ($event) {
                _vm.preview = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }